export default "__VITE_ASSET__BSwnE4Ju__"